import React, {Component, Fragment} from "react";
import Form from "../../../Leads/Form";
import {showToast} from "../../../../Common/Appcommon";

export default class EditView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            formname : props.formname || "",
            formid : props.formid || "",
            action : props.action || "",

        };
    }

    onsave = (formData) => {

        let {action} = this.state;

        let successMsg = "User created successfully.";
        if(action === "edit"){
            successMsg = "User updated successfully.";
        }
        showToast(successMsg,"top-right","success",()=>{
            window.location.href = "#/settings/account/users";
            window.location.reload();
        });
    }

    oncancel = () => {
        window.location.href = "#/settings/account/users";
        window.location.reload();
    }

    render() {

        let {formname, formid, action} = this.state;

        let title="Create User";

        if(action === "edit"){
            title = "Update User";
        }

        const addonButtons = [
            {
                'buttonTxt': 'Cancel',
                'buttonAction': this.oncancel,
                'buttonOutline': 'success',
                'buttonIcon': 'fa-times'
            }
        ]

        const defaultFields = {
            Default_Currency : "INR,Rs.",
            Time_Zone : "(GMT +05:30)-Asia/Kolkata"
        }

        return (
            <Fragment>
                <Form
                    formname={formname}
                    formid={formid}
                    settingsForm={true}
                    title={title}
                    onsave={this.onsave}
                    addonButtons={addonButtons}
                    defaultFields={defaultFields}
                />
            </Fragment>
        );
    }
}